import { render } from "./404.vue?vue&type=template&id=09c68b87&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=09c68b87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c68b87"],['__file',"src/views/error/404.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09c68b87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09c68b87', __exports__)) {
    api.reload('09c68b87', __exports__)
  }
  
  module.hot.accept("./404.vue?vue&type=template&id=09c68b87&scoped=true", () => {
    api.rerender('09c68b87', render)
  })

}


export default __exports__